var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"top-name"},[_c('p',{staticClass:"full-name"},[_c('span',[_vm._v("S")]),_vm._v("usanna"),_c('br'),_c('span',{staticClass:"tab"},[_vm._v("S")]),_vm._v("aadi")]),_c('div',{staticClass:"rose-line first"}),_c('div',{staticClass:"rose-line second"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }